<template lang="pug">
div
  el-row
    app-display(
      label="Denominação:",
      :content="imovel.denominacao"
      :class = "compararAforamentoImovel && compararAforamentoImovel.mudouDenominacao ? 'text': '' "
    )
    app-display(
      label="Município:",
      :content="imovel.municipio ? imovel.municipio.nome : ''",
      :class = "compararAforamentoImovel && compararAforamentoImovel.mudouMunicipio ? 'text': '' "
    )
    app-display(
      label="Área:",
      :content="formatAreaHectare(imovel.area)",
      :class = "compararAforamentoImovel && compararAforamentoImovel.mudouArea ? 'text': '' "
    )
    info-matricula(:imovel="imovel")
    app-collapse(title="Dados do título")
      app-display(
        label="Nome do beneficiário:",
        :content="getValue(imovel.nomeBeneficiarioTitulo)"
        :class = "compararAforamentoImovel && compararAforamentoImovel.mudouNomeBeneficiarioTitulo ? 'text': '' "
      )
</template>
<script>
import AppDisplay from '@/components/AppDisplay'
import AppCollapse from '@/components/AppCollapse'
import utils from '@/utils/utils'
import InfoMatricula from '@/components/informacoesCadastro/common/InfoMatricula'

export default {
  components: {
    InfoMatricula,
    AppCollapse,
    AppDisplay
  },
  props: {
    imovel: {
      type: Object,
      required: true
    },
    compararAforamentoImovel: {
      type: Object,
      required: true
    }

  },
  methods: {
    formatAreaHectare (area) {
      return utils.format(area) + ' hectare(s)'
    },
    getValue (params) {
      return params || '-'
    }
  }
}
</script>
<style lang="scss" scoped>
>>> .text .text{
    color: #ff0000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/cadastrosOnline/informacoesAforamento/InformacoesAforamentoImovel.vue